import { useMemo } from "react";

import {
    queryParam,
    useRegisterMetadata
} from "../hooks/use-registered-metadata";
import { ProductKey } from "../models";

import { DefaultProvisioningUI } from "./provisioning-flows/default-provisioning-ui";
import { JiraProvisioningUI } from "./provisioning-flows/jira-provisioning-ui";
import ViewSwitch from "./view-switch";

const { JIRA_SOFTWARE, JIRA_PRODUCT_DISCOVERY, JIRA_SERVICE_MANAGEMENT, LOOM } =
    ProductKey;

/**
 * Component renders the approriate UI given the product(s)
 * @returns @type {JSX.Element}
 */
export const ProductViewSwitch = () => {
    const metadata = useRegisterMetadata();
    const orderedProductsKeys = useMemo(() => {
        const items = (metadata?.get(queryParam.products) as string[]) ?? [];
        return items.sort().join(",");
    }, [metadata]);

    const LegacyViewSwitch = <ViewSwitch />;

    switch (orderedProductsKeys) {
        case JIRA_SOFTWARE:
            return <JiraProvisioningUI />;
        case JIRA_PRODUCT_DISCOVERY:
        case JIRA_SERVICE_MANAGEMENT:
        case LOOM:
            return <DefaultProvisioningUI />;
        default:
            return LegacyViewSwitch;
    }
};
